import {Injectable, Injector} from '@angular/core';
import {SystemConfig} from '../../config/system-config';
import {TimerService} from '../countdown/countdown-service';
import {WinningPlan} from '../../domain/winning-plan';
import {Tip} from '../../domain/tip';
import {Drawing} from '../../domain/drawing';
import {HistoryTicket} from '../../domain/history-ticket';
import {User} from '../../domain/user';
import {Settings} from '../../domain/settings';
import * as _ from 'lodash';
import {TransactionListElement} from '../../domain/transaction-list-element';

@Injectable()
export class SessionService {
  numbers: number[] = [];
  tickets: Tip[] = [];
  selectedTipIndex: number = 0;
  jackpot: number = 0;
  jackpotWonAmount: number = 0;
  showJackpotWon: boolean = false;
  countdown: TimerService;
  translations: Map<string, any> = new Map();
  winningPlan: WinningPlan[] = [];
  settings: Settings = Settings.defaultSettings;
  currentBingoGameId: number;
  drawings: Drawing[] = [];
  history: HistoryTicket[] = [];
  punter: User;
  showLogout: boolean = false;
  winner: boolean = false;
  lastStake: number = 0;
  showFundsDialog: boolean = false;
  showPayin: boolean = false;
  showPayout: boolean = false;
  showInfoBubbleSuccess: boolean = false;
  showInfoBubbleError: boolean = false;
  showTransactions: boolean = false;
  infoBubbleMessage: string = '';
  transactionList: TransactionListElement[] = [];
  isIframe: boolean = false;

  saveState(): void {
    try {
      localStorage.setItem('tickets', this.tickets.length > 0 ? JSON.stringify(this.tickets) : JSON.stringify([]));
      localStorage.setItem('selectedTipIndex', JSON.stringify(this.selectedTipIndex));
      localStorage.setItem('winningPlan', this.winningPlan.length > 0 ? JSON.stringify(this.winningPlan) : JSON.stringify([]));
      localStorage.setItem('history', this.history.length > 0 ? JSON.stringify(this.history) : JSON.stringify([]));
      localStorage.setItem('transactionList', this.transactionList.length > 0 ? JSON.stringify(this.transactionList) : JSON.stringify([]));
      localStorage.setItem('jackpot', JSON.stringify(this.jackpot));
    } catch (e) {
    }
  }

  restoreState(): void {
    try {
      this.tickets = JSON.parse(localStorage.getItem('tickets'));
      this.selectedTipIndex = +localStorage.getItem('selectedTipIndex');
      this.winningPlan = JSON.parse(localStorage.getItem('winningPlan'));
      this.history = JSON.parse(localStorage.getItem('history'));
      this.transactionList = JSON.parse(localStorage.getItem('transactionList'));
      this.jackpot = +localStorage.getItem('jackpot');
    } catch (e) {
    }
  }

  get animationTimePerBallInMs() {
    if (this.settings) {
      return Math.floor(this.settings.animationTime / SystemConfig.Constants.MAX_AMOUNTS_OF_BALLS);
    } else {
      return 500;
    }
  }

  get selectedTip(): Tip {
    const selectedTip: Tip[] = this.tickets.filter((t, idx) => this.selectedTipIndex === idx);
    return selectedTip.length === 1 ? selectedTip[0] : null;
  }

  get hits(): number {
    return this.numbers.filter((n: number) => this.selectedTip && this.selectedTip.numbers.indexOf(n) > -1).length;
  }

  constructor(public injector: Injector) {
    this.countdown = new TimerService(injector);
  }

  showInfoBubbleDialog(message: string, error?: boolean): void {
    if (error) {
      this.showInfoBubbleError = true;
    } else {
      this.showInfoBubbleSuccess = true;
    }

    this.infoBubbleMessage = message;
  }

  hideInfoBubbleDialog(): void {
    this.showInfoBubbleSuccess = false;
    this.showInfoBubbleError = false;
    this.infoBubbleMessage = '';
  }

  hideFundsDialogs(): void {
    this.showFundsDialog = false;
    this.showPayin = false;
    this.showPayout = false;
    this.showTransactions = false;
  }

  showPayinDialog(): void {
    this.showFundsDialog = false;
    this.showPayin = true;
  }

  showPayoutDialog(): void {
    this.showFundsDialog = false;
    this.showPayout = true;
  }

  showTransactionsDialog(): void {
    this.showFundsDialog = false;
    this.showTransactions = true;
  }

  removeInvalidTickets() {
    this.tickets.forEach(t => t.rounds--);
    _.remove(this.tickets, ticket => ticket.rounds <= 0);
  }

  logout() {
    this.showLogout = false;
    this.punter = null;
  }

  addTip(tip: Tip) {
    this.tickets.push(tip);
    this.selectedTipIndex = this.tickets.length - 1;
  }

  addNumber(n: number) {
    this.numbers.push(n);
  }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/services/session/session.service.ts